import { render, staticRenderFns } from "./ModalComentario.vue?vue&type=template&id=17ee6354&scoped=true&"
import script from "./ModalComentario.vue?vue&type=script&lang=js&"
export * from "./ModalComentario.vue?vue&type=script&lang=js&"
import style0 from "./ModalComentario.vue?vue&type=style&index=0&id=17ee6354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ee6354",
  null
  
)

export default component.exports